import { useEffect } from "react";

export function usePageTitle(...parts: (string | undefined | null | false)[]) {
  const title = [...parts.filter(Boolean), "nextsub"].join(" · ");
  useEffect(() => {
    document.title = title;
  }, [title]);
}
